import { RxCollectionCreator } from 'rxdb';

export const LmsSSSchema: RxCollectionCreator = {
	schema: {
		title: 'LMS SS Schema',
		description: 'Schema for LMS Site Specialists',
		version: 0,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			mdicode_c: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			phone_number_c: {
				type: 'string',
			},
			usertype_c: {
				type: 'string',
			},
		},
		required: ['sfid', 'id', 'name'],
	},
};
